import { render } from "./MiBadge.vue?vue&type=template&id=0b978a74&scoped=true"
import script from "./MiBadge.vue?vue&type=script&lang=js"
export * from "./MiBadge.vue?vue&type=script&lang=js"

import "./MiBadge.vue?vue&type=style&index=0&id=0b978a74&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b978a74"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge});
